export default "__VITE_ASSET__050bd0a2__"